import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BoundarySettingsContainer, type BoundarySettingsContainerProps,
} from './boundarySettings.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundarySettings: BoundarySettingsContainerProps;
  }
}
modalRenderer.register('BoundarySettings', BoundarySettingsContainer);
